<template>
  <div class="container">
    <h2 class="title">404</h2>
    <div class="subtitle">{{ $t("notFoundWebsite") }}</div>
    <a href="/" class="btn">{{ $t("comeBackToMain") }}</a>
  </div>
</template>

<script>
export default {
  name: "NotFound",
}
</script>

<style scoped lang="scss">
.container {
  text-align: center;
  padding: 4rem 1rem;
  margin: auto;
}

.title {
  font-size: 1.5rem;
}

.subtitle {
  font-size: 3rem;
  font-weight: bold;
  text-transform: uppercase;
}

.btn {
  color: inherit;
  font-weight: bold;
  border: 4px solid;
  padding: 1rem;
  margin-top: 4rem;
  display: block;

  &:hover {
    color: #fff;
    background: #000;
  }
}
</style>
